import React, { useState } from "react";
import { HeaderSection } from "../components/Headers/HeaderSection";
import { convertUriImg, openInNewTab } from "../utils/GlobalFunc";
import { HiChevronDown } from "react-icons/hi";
import { IoEyeOutline, IoClose } from "react-icons/io5";
import { PORTFOLIO, TITLE_PORTFOLIO } from "../constant/global";

export default function Portfolio() {
  const [active, setActive] = useState(0);
  const [dropdown, setDropdown] = useState(false);
  const [showProject, setShowProject] = useState("");

  return (
    <article className="portfolio active" data-page="portfolio">
      <HeaderSection title={"Portfolio"} />
      <section className="projects">
        <ul className="filter-list">
          {TITLE_PORTFOLIO?.map((x, i) => (
            <li className="filter-item" key={x}>
              <button
                className={i === active && "active"}
                onClick={() => setActive(i)}
              >
                {x}
              </button>
            </li>
          ))}
        </ul>
        <div className="filter-select-box">
          <button
            className={`filter-select ${dropdown && "active"}`}
            onClick={() => setDropdown(!dropdown)}
          >
            <div className="select-value" data-selecct-value>
              {TITLE_PORTFOLIO[active]}
            </div>
            <div className="select-icon">
              <HiChevronDown />
            </div>
          </button>
          <ul className="select-list">
            {TITLE_PORTFOLIO?.map((x, i) => (
              <li className="select-item" key={x}>
                <button
                  onClick={() => {
                    setActive(i);
                    setDropdown(false);
                  }}
                >
                  {x}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div
          className={`modal-container ${showProject ? "active" : ""}`}
          data-modal-container
        >
          <div className="overlay" data-overlay />
          <section className="testimonials-modal">
            <button
              className="modal-close-btn"
              onClick={() => setShowProject("")}
            >
              <IoClose />
            </button>
            <div className="modal-img-wrapper">
              <figure className="modal-project-box">
                {showProject.img && (
                  <img
                    src={convertUriImg("projects/" + showProject.img)}
                    alt={showProject.title}
                    loading="lazy"
                    data-modal-img
                  />
                )}
              </figure>
              {/* <img src="../../public/images/icon-quote.svg" alt="quote icon" /> */}
            </div>
            <div className="modal-content">
              <h4 className="h3 modal-title" data-modal-title>
                {showProject.title}
              </h4>
              <div
                className="timeline-list"
                style={{ marginLeft: 0, marginBottom: 18 }}
              >
                <span>{showProject.as}</span>
                <div data-modal-text>
                  <p>{showProject.desc}</p>
                </div>
                {showProject.links && (
                  <div className="info-content link-containter">
                    {showProject.links?.map((x, i) => (
                      <button
                        key={x.href}
                        className="title"
                        style={{ marginLeft: 0 }}
                        onClick={() => openInNewTab(x.href)}
                      >
                        {x.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
        <ul className="project-list">
          {PORTFOLIO?.map((x, i) => (
            <li
              key={x.title}
              className={`project-item ${
                (x.idActive === active ||
                  0 === active ||
                  x.idActive2 === active) &&
                "active"
              }`}
            >
              <button onClick={() => setShowProject(x)}>
                <figure className="project-img">
                  <div className="project-item-icon-box">
                    <IoEyeOutline />
                  </div>
                  {x.img && (
                    <img
                      src={convertUriImg("projects/" + x.img)}
                      alt={x.title}
                      loading="lazy"
                    />
                  )}
                </figure>
                <h3 className="project-title">{x.title}</h3>
                <p className="project-category">{x.desc}</p>
              </button>
            </li>
          ))}
        </ul>
      </section>
    </article>
  );
}
